/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://maiesq55j3.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "Entities",
            "endpoint": "https://jrw0n136s5.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "Hubspot",
            "endpoint": "https://cl66fc97i7.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "NetworkAPI",
            "endpoint": "https://ok96tc5u09.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "SensorData",
            "endpoint": "https://s39dduyy9d.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "TimestreamAPI",
            "endpoint": "https://xrmryax7f3.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "workspaceApi",
            "endpoint": "https://63x72hid31.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://2dvsoe3n65hmxjejyyvufiqnbq.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:3c4dc0e9-619b-404c-9bfd-346fd18f0952",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_q4ImDt4iD",
    "aws_user_pools_web_client_id": "3jb80keq7atp2t6i9trr4rs88l",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "workspacelogos150029-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "geo": {
        "amazon_location_service": {
            "region": "eu-west-1",
            "maps": {
                "items": {
                    "mapPrym-prod": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "mapPrym-prod"
            },
            "search_indices": {
                "items": [
                    "prymPlaceIndex-prod"
                ],
                "default": "prymPlaceIndex-prod"
            }
        }
    }
};


export default awsmobile;
